/* eslint-disable */
import t from "../../Actions/PlateValidateActions/type";

const initialState = {
  plateValidatePermitsData: [],
  error: "",
};

const LotPlateValidateReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch permit list
    case t.GET_PLATE_VALIDATE_PERMITS_SUCCESS: {
      return { ...state, plateValidatePermitsData: action.payload, error: "" };
    }
    case t.GET_PLATE_VALIDATE_PERMITS_FAILURE: {
      return { ...state, error: action.payload };
    }

    // Update permit active status
    case t.UPDATE_PERMIT_STATUS_SUCCESS: {
      if (!action.payload?.id) return state;
      const updatedList = state.plateValidatePermitsData.map((item) =>
        item.id === action.payload.id ? action.payload : item
      );
      return { ...state, plateValidatePermitsData: updatedList, error: "" };
    }
    case t.UPDATE_PERMIT_STATUS_FAILURE: {
      return { ...state, error: action.payload };
    }

    // Delete a permit
    case t.DELETE_PERMIT_SUCCESS: {
      const filteredList = state.plateValidatePermitsData.filter(
        (item) => item.id !== action.payload
      );
      return { ...state, plateValidatePermitsData: filteredList, error: "" };
    }
    case t.DELETE_PERMIT_FAILURE: {
      return { ...state, error: action.payload };
    }

    // Deactivate permits due to lot deletion
    case t.DEACTIVATE_PERMITS_ON_LOT_DELETE_SUCCESS: {
      const updatedPermits = action.payload ?? [];
      const updatedList = state.plateValidatePermitsData.map((item) => {
        const updated = updatedPermits.find((p) => p.id === item.id);
        return updated ? updated : item;
      });
      return { ...state, plateValidatePermitsData: updatedList, error: "" };
    }
    case t.DEACTIVATE_PERMITS_ON_LOT_DELETE_FAILURE: {
      return { ...state, error: action.payload };
    }
    case t.DELETE_PLATE_VALIDATE_DISCOUNT_SUCCESS: {
      const { lot_id } = action.payload;
      
      const filteredList = state.plateValidatePermitsData.filter(
        (permit) => permit.lot_id !== lot_id
      );

      return {
        ...state,
        plateValidatePermitsData: filteredList,
        error: "",
      };
    }
    default:
      return state;
  }
};

export default LotPlateValidateReducer;